import { injectPlatform } from "./internal";

// PDT logger (client metric logging)
export { log as pdtLog } from "./pdtLogger";
export type { PdtEventPayload, PdtLogParams } from "./pdtLogger";
export {
  initGlobalErrorLogging,
  storePageTransitionStart,
} from "./pdtLogger/globalErrorLogging";

export function getInternalSource({
  extraParams = [],
  fallback = "",
}: {
  extraParams?: string[];
  fallback?: string;
} = {}): string {
  if (typeof window === "undefined") return "";
  const params = new URLSearchParams(window.location.search);
  return (
    params.get("internal_source") ||
    extraParams.reduce<string | null>(
      (result, key) => result || params.get(key),
      null
    ) ||
    sessionStorage.getItem("internal_source") ||
    fallback
  );
}

export const pushEvent = (eventObj: any) => {
  const isClientSide =
    typeof navigator !== "undefined" && typeof window !== "undefined";
  if (!isClientSide) return;

  injectPlatform(eventObj);

  // @ts-ignore
  window.adobeDataLayer = window.adobeDataLayer || [];
  // @ts-ignore
  window.adobeDataLayer.push(eventObj);
};
